import React, { useEffect } from "react";
import { View, Text } from "react-native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import { createStackNavigator } from "@react-navigation/stack";
import { HomeScreen } from "../screens/home";
import { CallHistoryList } from "../screens/call-history-list";
import { PreOfferChatList } from "../screens/pre-offer-chat-list";
import { OffersScreen } from "../screens/offers";
import { MyPageScreen } from "../screens/my-page";
import OfferScreen from "src/screens/offer";
import { LikedServiceScreen } from "src/screens/liked-servies";
import { BlockedUsersScreen } from "src/screens/blocked-users";
import { ReviewByUserAsUserScreen } from "src/screens/review-by-user-as-user";
import { ReviewByUserAsServiceOwnerScreen } from "src/screens/review-by-user-as-service-owner";
import { MyProfile } from "src/screens/my-profile";
import { CustomSelectionList } from "src/screens/custom-selection-list";
import { Notifications } from "src/screens/notifications";
import { Notification } from "src/screens/notification";
import { ReviewByOfferScreen } from "src/screens/review-by-offer";
import { ReviewByOfferToUserScreen } from "src/screens/review-by-offer-to-user";
import { UserScreen } from "src/screens/user";
import { MyAccountScreen } from "src/screens/my-account";
import { MyAccountEmailScreen } from "src/screens/my-account-email";
import { MyAccountPasswordScreen } from "src/screens/my-account-password";
import { HomeFilterScreen } from "src/screens/home-filter";
import { OfferEditScreen } from "src/screens/offer-edit";
import { CustomTextEdit } from "src/screens/custom-text-edit";
import { CallRequestScreen } from "src/screens/call-request";
import { CallHistoryScreen } from "src/screens/call-history";
import { CallScreen } from "src/screens/call";
import { CallChatScreen } from "src/screens/call-chat";
import { ReviewScreen } from "src/screens/review";
import { SalesHistoryScreen } from "src/screens/sales-history";
import { WithdrawalScreen } from "src/screens/withdrawal";
import { WithdrawalRequestScreen } from "src/screens/withdrawal-request";
import { WithdrawalDescriptionScreen } from "src/screens/withdrawal-description";
import { BalanceScreen } from "src/screens/balance";
import { PreOfferChatScreen } from "src/screens/pre-offer-chat";
import { OwnerScreen } from "src/screens/owner";
import { MyAddress } from "src/screens/my-address";
import { CreditCardScreen } from "src/screens/credit-card";
import { IdentificationScreen } from "src/screens/identification";
import { CustomImageCropScreen } from "src/screens/custom-image-crop";
import { AuthLandingScreen } from "src/screens/auth-landing";
import { AuthPasswordResetScreen } from "src/screens/auth-password-reset";
import { AuthSignInScreen } from "src/screens/auth-signin";
import { AuthSignUpScreen } from "src/screens/auth-signup";
import { AuthSignUpConfirmScreen } from "src/screens/auth-signup-confirm";
import { PrivacyPolicyScreen } from "src/screens/privacy-policy";
import { TermsScreen } from "src/screens/terms";
import {
  Icon,
  PreOfferChatTabIcon,
  OfferTabIcon,
  MyPageTabIcon,
} from "src/components";
import { navigation as navigationStyles } from "src/assets";
import LocalText from "src/local";
import { RootStackParamList, MainTabParamList } from "./types";
import { useAuth, AuthState } from "src/hooks/cognito";

const Tab = createBottomTabNavigator<MainTabParamList>();
const Stack = createStackNavigator<RootStackParamList>();

export const Loading: React.FC = () => {
  return (
    <View>
      <Text>Loading</Text>
    </View>
  );
};

export const Tabs: React.FC = () => {
  const auth = useAuth();
  return (
    <Tab.Navigator>
      <Tab.Screen
        name="Search"
        component={HomeScreen}
        options={{
          ...navigationStyles.defaultNavigationOptions,
          title: LocalText.screens.home.navigationBarTopTitle,
          tabBarLabel: LocalText.navigation.home,
          tabBarLabelPosition: "below-icon",
          tabBarIcon: ({ color }: any) => (
            <Icon name="search" color={color} size={24} />
          ),
          tabBarStyle: { display: auth === AuthState.Auth ? "flex" : "none" },
        }}
      />
      {/* {auth === AuthState.Auth && ( */}
      {/* <Tab.Group> */}
      <Tab.Screen
        name="PreOfferChatList"
        component={PreOfferChatList}
        options={{
          ...navigationStyles.defaultNavigationOptions,
          headerShown: false,
          tabBarLabel: LocalText.navigation.preOfferChatList,
          tabBarLabelPosition: "below-icon",
          tabBarIcon: ({ color }: any) => <PreOfferChatTabIcon color={color} />,
        }}
      />
      <Tab.Screen
        name="CallHistoryList"
        component={CallHistoryList}
        options={{
          ...navigationStyles.defaultNavigationOptions,
          headerShown: false,
          tabBarLabel: LocalText.navigation.callHistoryList,
          tabBarLabelPosition: "below-icon",
          tabBarIcon: ({ color }: any) => <OfferTabIcon color={color} />,
        }}
      />
      <Tab.Screen
        name="Offers"
        component={OffersScreen}
        options={{
          ...navigationStyles.defaultNavigationOptions,
          title: LocalText.screens.offers.navigationBarTopTitle,
          tabBarLabel: LocalText.navigation.offers,
          tabBarLabelPosition: "below-icon",
          tabBarIcon: ({ color }: any) => (
            <Icon name="plus" color={color} size={24} />
          ),
        }}
      />
      <Tab.Screen
        name="MyPage"
        component={MyPageScreen}
        options={{
          ...navigationStyles.defaultNavigationOptions,
          title: LocalText.screens.myPage.navigationBarTopTitle,
          tabBarLabel: LocalText.navigation.myPage,
          tabBarLabelPosition: "below-icon",
          tabBarIcon: ({ color }: any) => <MyPageTabIcon color={color} />,
        }}
      />
      {/* </Tab.Group> */}
      {/* )} */}
    </Tab.Navigator>
  );
};

export const NavigationProvider: React.FC = () => {
  const auth = useAuth();

  // FIXME: Hide unused screens on unath
  return (
    <React.Fragment>
      <Stack.Navigator initialRouteName="Main">
        <Stack.Screen
          name="Main"
          component={Tabs}
          options={{ headerShown: false }}
        />
        <Stack.Group screenOptions={{ presentation: "modal" }}>
          <Stack.Screen
            name="Auth"
            component={AuthLandingScreen}
            options={{
              ...navigationStyles.defaultNavigationOptions,
            }}
          />
        </Stack.Group>
        <Stack.Screen
          name="SignIn"
          component={AuthSignInScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.screens.authSignIn.navigationBarSignInTitle,
          }}
        />
        <Stack.Screen
          name="PasswordReset"
          component={AuthPasswordResetScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.screens.authSignIn.navigationBarPasswordResetTitle,
          }}
        />
        <Stack.Screen
          name="SignUp"
          component={AuthSignUpScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.screens.authSignup.navigationBarSignUpTitle,
          }}
        />
        <Stack.Screen
          name="SignUpConfirm"
          component={AuthSignUpConfirmScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.screens.authSignup.navigationBarConfirmTitle,
          }}
        />
        <Stack.Screen
          name="Offer"
          component={OfferScreen}
          options={{
            headerShown: false,
          }}
        />
        <Stack.Screen
          name="Owner"
          component={OwnerScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.navigation.owner,
          }}
        />
        <Stack.Screen
          name="ReviewByOffer"
          component={ReviewByOfferScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.navigation.review,
          }}
        />
        {auth === AuthState.Auth && (
          <Stack.Group>
            <Stack.Screen
              name="LikedService"
              component={LikedServiceScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.likedService,
              }}
            />
            <Stack.Screen
              name="BlockedUsers"
              component={BlockedUsersScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.blockedUsers,
              }}
            />
            <Stack.Screen
              name="ReviewByUserAsUser"
              component={ReviewByUserAsUserScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
              }}
            />
            <Stack.Screen
              name="ReviewByUserAsServiceOwner"
              component={ReviewByUserAsServiceOwnerScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
              }}
            />
            <Stack.Screen
              name="MyProfile"
              component={MyProfile}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.myProfile,
              }}
            />
            <Stack.Screen
              name="CustomSelectionList"
              component={CustomSelectionList}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                headerLeft: () => null,
              }}
            />
            <Stack.Screen
              name="Notifications"
              component={Notifications}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.notifications,
              }}
            />
            <Stack.Screen
              name="Notification"
              component={Notification}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.notifications,
              }}
            />
            <Stack.Screen
              name="ReviewByOfferToUser"
              component={ReviewByOfferToUserScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.review,
              }}
            />
            <Stack.Screen
              name="User"
              component={UserScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
              }}
            />
            <Stack.Screen
              name="MyAccount"
              component={MyAccountScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.myAccount,
              }}
            />
            <Stack.Screen
              name="MyAccountEmail"
              component={MyAccountEmailScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.myAccountEmail,
              }}
            />
            <Stack.Screen
              name="MyAccountPassword"
              component={MyAccountPasswordScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.myAccountPassword,
              }}
            />
            <Stack.Screen
              name="HomeFilter"
              component={HomeFilterScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.homeFilter,
              }}
            />
            <Stack.Screen
              name="OfferEdit"
              component={OfferEditScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.offerEdit,
                headerLeft: () => null,
              }}
            />
            <Stack.Screen
              name="CustomTextEdit"
              component={CustomTextEdit}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                headerLeft: () => null,
              }}
            />
            <Stack.Screen
              name="CallRequest"
              component={CallRequestScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.callRequest,
                headerLeft: () => null,
              }}
            />
            <Stack.Screen
              name="CallHistory"
              component={CallHistoryScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.callHistory,
                headerLeft: () => null,
              }}
            />
            <Stack.Screen
              name="Call"
              component={CallScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                headerLeft: () => null,
              }}
            />
            <Stack.Screen
              name="CallChat"
              component={CallChatScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
              }}
            />
            <Stack.Screen
              name="Review"
              component={ReviewScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.review,
              }}
            />
            <Stack.Screen
              name="SalesHistory"
              component={SalesHistoryScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.salesHistory,
              }}
            />
            <Stack.Screen
              name="Withdrawal"
              component={WithdrawalScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.withdrawal,
              }}
            />
            <Stack.Screen
              name="WithdrawalRequest"
              component={WithdrawalRequestScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.withdrawalRequest,
              }}
            />
            <Stack.Screen
              name="WithdrawalDescription"
              component={WithdrawalDescriptionScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.withdrawalDescription,
              }}
            />
            <Stack.Screen
              name="Balance"
              component={BalanceScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.balance,
              }}
            />
            <Stack.Screen
              name="PreOfferChat"
              component={PreOfferChatScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: "",
              }}
            />
            <Stack.Screen
              name="MyAddress"
              component={MyAddress}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.myAddress,
              }}
            />
            <Stack.Screen
              name="CreditCard"
              component={CreditCardScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.creditCard,
              }}
            />
            <Stack.Screen
              name="Identification"
              component={IdentificationScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                title: LocalText.navigation.identification,
              }}
            />
            <Stack.Screen
              name="CustomImageCrop"
              component={CustomImageCropScreen}
              options={{
                ...navigationStyles.defaultNavigationOptions,
                headerLeft: () => null,
              }}
            />
          </Stack.Group>
        )}
        <Stack.Screen
          name="PrivacyPolicy"
          component={PrivacyPolicyScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.navigation.privacyPolicy,
          }}
        />
        <Stack.Screen
          name="Terms"
          component={TermsScreen}
          options={{
            ...navigationStyles.defaultNavigationOptions,
            title: LocalText.navigation.terms,
          }}
        />
      </Stack.Navigator>
    </React.Fragment>
  );
};
